const humanizeGasChargeLabel = (charge) =>
  (charge?.subtype || charge?.type || 'Charge')
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export default humanizeGasChargeLabel;
